import React from 'react';
import PropTypes from 'prop-types';

export default function NewPageHeader({ children, insideContainer = true, title }) {
  return (
    <div className={`ds-page-header ${insideContainer ? 'ds-page-header-inside-container' : ''}`}>
      <div className="d-flex justify-content-between align-items-center my-4">
        <h4>{title}</h4>
        {children}
      </div>
    </div>
  );
}

NewPageHeader.propTypes = {
  children: PropTypes.node,
  insideContainer: PropTypes.bool,
  title: PropTypes.string.isRequired
};
